<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div fxlayout="column" *ngIf="task">
  <span class="section_header" i18n="task details section header@@taskDetails">Task details</span>

  <!-- general data -->
  <div class="detail-general-data" fxLayout="column">
    <div
      class="task_properties"
      fxLayout="row"
      fxLayoutAlign="start center"
      *ngIf="task.description"
    >
      <span class="task_properties_title" i18n="description label@@descriptionLabel"
        >Description:</span
      >
      <span class="task_properties_value">{{ task.description }}</span>
    </div>
    <!-- employee/employee-group -->
    <app-task-assignee-detail
      [class.task_properties]="
        task.assignedToEmployeeOrEmployeegroup === TaskAssignmentType.EMPLOYEEGROUP
      "
      #taskAssigneeDetail
      [assignees]="task.assignedTo"
      [assigneeType]="task.assignedToEmployeeOrEmployeegroup"
    ></app-task-assignee-detail>

    <!-- employee/employee-group -->
    <div
      *ngIf="
        (task.assignedToEmployeeOrEmployeegroup === TaskAssignmentType.EMPLOYEE &&
          task.assignedTo &&
          task.assignedTo.length > 0) || task.isClaimed
      "
    >
      <div
        class="task_properties"
        *ngIf="
          (task.assignedToEmployeeOrEmployeegroup === TaskAssignmentType.EMPLOYEE &&
            employeeExists(task.claimedBy || task.assignedTo[0])) ||
          task.assignedToEmployeeOrEmployeegroup === TaskAssignmentType.EMPLOYEEGROUP
        "
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <span class="task_properties_title" i18n="claimed by label@@claimedBy">Assignee</span>

        <div class="filter_chips_row" fxLayout="row">
          <div *ngIf="employeeExists(task.claimedBy || task.assignedTo[0]); else invalidClaimee">
            <span class="task_properties_value" style="margin-right: 8px">
              {{ getEmployeeName(task.claimedBy || task.assignedTo[0]) }}
            </span>
          </div>

          <ng-template #invalidClaimee>
            <div class="task_properties_value missing_claimee_label">
              <fa-icon [icon]="faExclamationTriangle"></fa-icon>
              <span i18n="@@employeeNotFound">Employee not found</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- participants -->
    <div
      class="task_properties"
      fxLayout="row"
      fxLayoutAlign="start center"
      *ngIf="
        visibleParticipantIds.length > 0 &&
        (task.status === TaskStatus.IN_PROGRESS || task.status === TaskStatus.CLOSED)
      "
    >
      <span class="task_properties_title" i18n="participants label@@participants"
        >{visibleParticipantIds.length, plural, =1 {Participant} other {Participants}}</span
      >
      <span class="task_properties_value">
        {{ getParticipantNames(visibleParticipantIds) }}
      </span>
    </div>

    <!-- workflow name -->
    <div class="task_properties" fxLayout="row" fxLayoutAlign="start center">
      <span class="task_properties_title" i18n="workflow label@@workflow">Workflow</span>
      @if (enableLink) {
      <nav-link
        [route]="getWorkflowRoute(task.workflowId)"
        [text]="task.workflow_name ?? workflowName"
      ></nav-link>
      } @else {
      <span>{{ workflowName }}</span>
      }
    </div>
    <!-- tags -->
    <div
      class="task_properties"
      fxLayout="row"
      fxLayoutAlign="start start"
      *ngIf="task.tags.length > 0"
    >
      <span class="task_properties_title" i18n="tag label@@tags">Tags</span>
      <div>
        @for (tag of task.tags.slice(0, 3); track tag) {
        <span class="tag_container">{{ tag }}</span>
        } @if (task.tags.length > 3) {
        <button mat-button class="expand_button" (click)="showAllTags = !showAllTags">
          {{ showAllTags ? showLessButtonText : showAllButtonText }}
          @if (showAllTags) {
          <fa-icon id="showLessTagsIcon" class="icon_small" [icon]="faChevronUp"></fa-icon>
          } @else {
          <fa-icon id="showAllTagsIcon" class="icon_small" [icon]="faChevronDown"></fa-icon>
          }
        </button>
        } @if (showAllTags && task.tags.length > 3) { @for (tag of task.tags.slice(3); track tag) {
        <span class="tag_container">{{ tag }}</span>
        } }
      </div>
    </div>
    <!-- references -->
    <div
      class="task_properties"
      fxLayout="row"
      fxLayoutAlign="start start"
      *ngIf="task.references!.length > 0"
    >
      <span class="task_properties_title" i18n="references label@@references">References</span>
      <div>
        @for (reference of task.references!.slice(0, 3); track reference) {
        <span class="tag_container">
          {{ reference.refType + ': ' }}
          @if (enableLink) {
          <span class="link" (click)="setReferenceFilter(reference)">
            {{ reference.refValue }}
            <fa-icon id="referenceFilterIcon" class="icon link" [icon]="faSearch"></fa-icon>
          </span>
          } @else {
          <span>
            {{ reference.refValue }}
          </span>
          }
        </span>
        } @if (task.references!.length > 3) {
        <button mat-button class="expand_button" (click)="showAllReferences = !showAllReferences">
          {{ showAllReferences ? showLessButtonText : showAllButtonText }}
          @if (showAllReferences) {
          <fa-icon id="showLessReferencesIcon" class="icon_small" [icon]="faChevronUp"></fa-icon>
          } @else {
          <fa-icon id="showAllReferencesIcon" class="icon_small" [icon]="faChevronDown"></fa-icon>
          }
        </button>
        } @if (showAllReferences && task.references!.length > 3) { @for (reference of
        task.references!.slice(3); track reference) {
        <span class="tag_container">
          {{ reference.refType + ': ' }}
          @if (enableLink) {
          <span class="link" (click)="setReferenceFilter(reference)">
            {{ reference.refValue }}
            <fa-icon id="referenceFilterIcon" class="icon link" [icon]="faSearch"></fa-icon>
          </span>
          } @else {
          <span>
            {{ reference.refValue }}
          </span>
          }
        </span>
        } }
      </div>
    </div>

    <span class="section_header" i18n="task history section header@@taskHistory">Task history</span>

    <!-- Scheduled for -->
    <app-date-property
      *ngIf="task.scheduled_at"
      label="Scheduled for"
      [date]="task.scheduled_at"
      i18n-label="scheduled for label@@scheduledFor"
    >
    </app-date-property>

    <!-- Created at -->
    <app-date-property
      label="Created"
      [date]="task.createdAt"
      i18n-label="created at label@@createdAt"
    >
    </app-date-property>

    <div *ngIf="task.status !== TaskStatus.NEW && getStartedAt()" class="task_properties" fxLayout="row" fxLayoutAlign="start center">
      <span class="task_properties_title" i18n="started label@@started">Started</span>
      <span class="task_properties_value">{{ getStartedAt() }}<span *ngIf="getStartedBy()">, {{ getStartedBy() }}</span></span>
    </div>

    <!-- Updated at -->
    <app-date-property
      *ngIf="task.status === TaskStatus.IN_PROGRESS"
      label="Updated"
      [date]="task.updatedAt"
      i18n-label="last updated on label@@lastUpdated"
    >
    </app-date-property>

    <div *ngIf="task.status === TaskStatus.CLOSED && task.closedAt" class="task_properties" fxLayout="row" fxLayoutAlign="start center">
      <span *ngIf="task.currentState > 0" class="task_properties_title" i18n="closed label@@Closed">Closed</span>
      <span *ngIf="task.currentState <= 0" class="task_properties_title text-capitalize" i18n="@@finishedTaskChip">Finished</span>
      <span class="task_properties_value">{{ customDateFormatService.formatDate(task.closedAt) }}<span *ngIf="task.closedBy">, {{ getEmployeeName(task.closedBy) }}</span></span>
    </div>

    <div *ngIf="task.status === TaskStatus.IN_PROGRESS && getCurrentItemTitle()" class="task_properties" fxLayout="row" fxLayoutAlign="start center">
      <span class="task_properties_title" i18n="current item label@@currentItem">Current item</span>
      <span class="task_properties_value">{{ getCurrentItemTitle() }}</span>
    </div>
    <!-- Scheduled at -->
    <app-date-property
      *ngIf="task.scheduled_at"
      label="Scheduled for"
      [date]="task.scheduled_at"
      i18n-label="Scheduled for@@scheduledFor">
    </app-date-property>

    <!-- Total distance traveled -->
    <div
      *ngIf="task.tracing && task.tracing.totalTravelDistance != null"
      class="task_properties"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <span
        class="task_properties_title"
        i18n="Total distance traveled label@@totalDistanceTraveled"
        >Total distance traveled</span
      >
      <ng-container *ngIf="(task.tracing?.totalTravelDistance ?? 0) < 1000; else kilometers">
        <span class="task_properties_value">
          {{ task.tracing.totalTravelDistance | number : '1.2-2' }} m
        </span>
      </ng-container>
      <ng-template #kilometers>
        <span class="task_properties_value">
          {{ task.tracing.totalTravelDistance / 1000 | number : '1.2-2' }} km
        </span>
      </ng-template>
    </div>
    <ng-container
      *ngTemplateOutlet="taskAssigneeDetail.missingAssigneeNoticeBox ?? null"
    ></ng-container>
  </div>
</div>
